import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// PL
import plStatuses from "./locales/pl/statuses.json";
import plDocuments from "./locales/pl/documents.json";
import plPayments from "./locales/pl/payments.json";
import plNotifications from "./locales/pl/notifications.json";
import plAdmin from "./locales/pl/admin.json";
import plCommon from "./locales/pl/common.json";

// EN
import enStatuses from "./locales/en/statuses.json";
import enDocuments from "./locales/en/documents.json";
import enPayments from "./locales/en/payments.json";
import enNotifications from "./locales/en/notifications.json";
import enAdmin from "./locales/en/admin.json";
import enCommon from "./locales/en/common.json";

const savedLanguage = localStorage.getItem("appLanguage") || "pl";

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: "pl",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      pl: {
        statuses: plStatuses,
        documents: plDocuments,
        common: plCommon,
        payments: plPayments,
        notifications: plNotifications,
        admin: plAdmin,
      },
      en: {
        statuses: enStatuses,
        documents: enDocuments,
        common: enCommon,
        payments: enPayments,
        notifications: enNotifications,
        admin: enAdmin,
      },
    },
  });

export default i18n;